<div ng-show="request.procecssType==onboard && onboardStatus && onboardStatus.candidateId &&
  && onboardStatus.position && onboardStatus.hiringManagerName && onboardStatus.dueDate" class="css-global-info">

  <div class="well well-lg" style="max-width:900px;min-width:275px;display:inline-block;">
    You are applying for the <strong>{{onboardStatus.position}}</strong> position reporting to <strong>{{onboardStatus.hiringManagerName}}</strong>. Please complete the Employment Application by
    <strong>{{ onboardStatus.dueDate | date:'longDate' }}</strong>. For your reference, your candidate identification is <strong>{{onboardStatus.candidateId}}</strong>.
  </div>
</div>

<p-steps [model]="workflowSteps" [(activeIndex)]="workflowIndex" [readonly]="!interactive" styleClass="steps-custom"></p-steps>
